<template>
  <Hero :title="data?.title" :narrow="true"/>
  <main class="main maxw--body grid--third-twos block gap--double">
    <div>
      <nuxt-img v-if="data.image" provider="strapi" :src="getStrapiImageLocation(data.image)" class="fit mb-2"></nuxt-img>
      <div class="card">
        <div class="grid--two gap--halve">
          <b>Jaar:</b><span>{{ data?.year_date_active }}</span>
          <b>Leeftijd:</b><span>{{ data?.age }}</span>
          <b>Virgo lid:</b><span>{{ data?.year_amount_active }}</span>
          <b>Mailadres:</b><a :href="`mailto:${data?.email}`" class="link--flat link--light-up">{{ data?.email }}</a>
        </div>
      </div>
    </div>
    <div>
      <h2 class="mb-2">{{ data?.name }}</h2>
      <div v-html="$md.render(data?.about || '')" class="rendered"></div>
    </div>
  </main>
</template>

<script lang="ts" setup>
import ManagementMember from "~/typings/management_member";

const route = useRoute();
const { findOne } = useStrapi();

const { data, pending } = await useAsyncData(
  'eventpage',
  () => findOne<ManagementMember>('slugify/slugs/management-member/' + route.params.slug, { populate: 'image' }),
  {
    transform: flattenStrapiObject
  }
);

if (!data.value && !pending.value) {
  throw createError({ statusCode: 404, statusMessage: 'Bestuurslid niet gevonden' });
}

useHead({
  title: `Album: ${data.value?.title || ''}`
});

useHead({
  title: `Bestuur: ${data.value?.title}`
});
</script>
